import { Component, OnInit, Input, ViewChild, inject, ElementRef, effect } from '@angular/core'
import { doc } from '@angular/fire/firestore'
import { FeatureFlagService } from 'src/app/feature-flag.service'
import { AuthService } from 'src/app/services/auth.service'
import { AuthenticationService } from 'src/app/services/firebase/authentication.service'
import { HelperService } from 'src/app/services/helper.service'
import { NotificationsService } from 'src/app/services/notifications.service'
import { snapshot$ } from 'src/firebase-utils'
import { NgClass } from '@angular/common';
import { FeatureFlagDirective } from '../../../../feature-flag.directive';
import { MatRipple } from '@angular/material/core';
import { RouterLinkActive, RouterLink } from '@angular/router';
import { MatIcon } from '@angular/material/icon';
import { MatDivider } from '@angular/material/divider';
import { UserMenuItemComponent } from '../../../../user-menu-item/user-menu-item.component';
import { MatButton, MatIconButton } from '@angular/material/button';
import { MatTooltip } from '@angular/material/tooltip';
import { MatMenuTrigger, MatMenu } from '@angular/material/menu';
import { MatBadge } from '@angular/material/badge';
import { NotificationsComponent } from '../../../menus/notifications/notifications.component';

@Component({
    selector: 'app-vertical-menu',
    templateUrl: './vertical-menu.component.html',
    styleUrls: ['./vertical-menu.component.scss'],
    standalone: true,
    imports: [NgClass, FeatureFlagDirective, MatRipple, RouterLinkActive, RouterLink, MatIcon, MatDivider, UserMenuItemComponent, MatButton, MatIconButton, MatTooltip, MatMenuTrigger, MatBadge, MatMenu, NotificationsComponent]
})
export class VerticalMenuComponent implements OnInit {

  private _user = inject(AuthService)
  public helper = inject(HelperService)
  private featureFlagFacade = inject(FeatureFlagService)
  notificationsService = inject(NotificationsService)


  private auth = inject(AuthService)
  private fba = inject(AuthenticationService)
  @Input() state

  user: any
  menuState: string = 'expanded'
  menuElements: any[] = [
    {
      name: 'Fabrics',
      outlined: true,
      icon: 'format_paint',
      route: '/fabrics'
    },
    {
      name: 'Image Bank',
      icon: 'wallpaper',
      route: '/image-bank'
    },
    {
      name: 'Grids and layouts',
      outlined: true,
      icon: 'dashboard',
      route: '/grid-designer'
    },
    {
      name: 'Products',
      icon: 'list',
      route: '/products'
    },
    {
      name: 'Raw Tables',
      icon: 'table_restaurant',
      route: '/raw-table-manager'
    },
    {
      name: 'Collections',
      outlined: true,
      icon: 'category',
      route: '/collections'
    },
    {
      name: 'Reviews',
      outlined: true,
      icon: 'reviews',
      route: '/review'
    },
    {
      name: 'Deploy',
      outlined: true,
      icon: 'cloud_upload',
      route: '/deploy'
    }
  ]

  adminMenu: any[] = [
    {
      name: 'Users',
      icon: 'group',
      outlined: true,
      route: '/admin/user'
    },
    {
      name: 'User Groups',
      icon: 'settings_account_box',
      outlined: true,
      route: '/admin/user-groups'
    },
    {
      name: 'Notifications',
      outlined: true,
      icon: 'chat',
      route: '/admin/notifications'
    },
    {
      name: 'Attributes',
      outlined: true,
      icon: 'edit_attributes',
      route: '/admin/attributes'
    },
    {
      name: 'Product Models',
      outlined: true,
      icon: 'hexagon',
      route: '/admin/product-models'
    },
    {
      name: 'Prompt Settings',
      outlined: true,
      svgIcon: `gpt`,
      route: '/admin/prompt-settings'
    }
  ]

  public isAdmin: boolean = false
  public notifications: number = 0

  constructor() {
    // Checks if any admin rules are active for the user, to decide if the admin title should be shown
    effect(() => {

      let featureData = this.featureFlagFacade.data()

      if(featureData?.menu?.admin) {
        this.isAdmin = Object.values(featureData.menu.admin).some((state) => state)
      }
    })
  }

  @ViewChild('menu') public menu: ElementRef<HTMLElement>

  ngOnInit(): void {
    this._user.user$.subscribe((user) =>  this.user = user)
    this.helper.sidenav$.subscribe((result) => this.menuState = result)


    console.log(this.adminMenu)

    let interval = setInterval(() => {
      if(this.user) {
        clearInterval(interval)
  
        const docRef = doc(this.notificationsService.notificationRef, this.user.uid)
        snapshot$(docRef).subscribe((response) => {
          if(response) {
            this.notifications = Object.values(response).filter((notification: any) => notification.read == false).length
          }
        })
      }
    }, 100)
  }

  signOut() {
    this.fba.signOutUser()
    this.auth.user = undefined // Destroy the authenticated user, this is crude and may cause issues. Look into this
  }
}
